export default __webpack_public_path__ + "static/media/gsatellite.31f97cdc.jpg";